import angular from 'angular';
import cmsACL from '../../ACL/ACLService';

/**
 * @memberOf cms.input.color
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.title      Input title and/or placeholder
 * @property {function} bindings.onBlur     Function called on input blur event
 * @property {function} bindings.onChange   Function called on input change event
 */
let cmsInputColor = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@'
    },
    template: require('./color.html'),

    controller: function() {

        this.colors =[
            '#ef5350','#ec407a','#ab47bc','#7e57c2','#5c6bc0','#42a5f5','#29b6f6','#26c6da',
            '#26a69a','#f44336','#e91e63','#9c27b0','#673ab7','#3f51b5','#2196f3','#03a9f4',
            '#00bcd4','#009688','#d32f2f','#d81b60','#8e24aa','#5e35b1','#3949ab','#1e88e5',
            '#039be5','#00acc1','#00897b','#64ffda','#66bb6a','#d4e157','#f3d390','#ffca28',
            '#ffa726','#ff7043','#c2185b','#7b1fa2','#1de9b6','#4caf50','#cddc39','#f2ce82',
            '#ffc107','#ff9800','#ff5722','#ad1457','#603775','#13c2a5','#43a047','#c0ca33',
            '#efc468','#fdb722','#fb8c00','#f4511e','#880e4f','#4e2b61','#512da8','#303f9f',
            '#1976d2','#ffffff','#e0e0e0','#78909c','#455a64','#192a3a','#8d6e63','#4527a0',
            '#283593','#1565c0','#f5f5f5','#bdbdbd','#607d8b','#37474f','#101e2a','#795548',
            '#311b92','#1a237e','#0d47a1','#eeeeee','#757575','#546e7a','#212121','#000000',
            'transparent'
        ];

        this.isShowPalette = false;

        this.togglePalette = () => {
            if (this.isShowPalette === false) {
                this.isShowPalette = true;
            } else  {
                this.isShowPalette = false;
            }
        };

    }
};

/**
 * Color control
 * @namespace cms.input.color
 */
export default angular.module('cms.input.color', [cmsACL]).component('cmsInputColor', cmsInputColor).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/ColorControl/CmsInputColor.js